import { createPromiseFunctionWithDelay } from '../../utils/promise';
import './../../shop/modules/multi_checkout/services.multi-checkout';
import dayjs from 'dayjs';
import { DESTINATION_TYPES } from './constants/destinationType';
import onLogError from '../../utils/onLogError';
import { PAGE_TYPE } from '../../constants/logger';

app.directive('destinationSectionFamilyMartFrozen', [
  'mainConfig',
  'multiCheckoutService',
  function (mainConfig, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.family-mart-frozen.html'),
      scope: {
        store: '=',
        option: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
      },
      link: function (scope) {
        const DATE_FORMAT = 'YYYY-MM-DD';

        scope.actionUrl = mainConfig.familyMartFrozenConfig?.emap;

        scope.getConfigValues = () => {
          const CvsTemp = `${window.location.protocol}//${window.location.host}`;
          const leadTime = scope.option.config_data?.lead_time || 1;
          const StartDate = dayjs().add(leadTime + 1, 'day');
          const EndDate = StartDate.add(7, 'day');
          const frozenDeliveryConfig = {
            CvsTemp,
            CvsName: mainConfig.familyMartFrozenConfig?.cvsname,
            CvsLink: mainConfig.familyMartFrozenConfig?.cvslink,
            CvSid: '11111111',
            Exchange: 'true',
            Items: [
              {
                ParentId: scope.option.config_data?.parentid,
                Eshopid: scope.option.config_data?.shopid,
                ChanItem: '0000000000',
                EshopType: '9',
                Length: 45,
                Wide: 30,
                High: 30,
                Weight: 0,
                Qty: 1,
                StartDate: StartDate.format(DATE_FORMAT),
                EndDate: EndDate.format(DATE_FORMAT),
              },
            ],
          };

          return frozenDeliveryConfig;
        };

        const trackerPromiseWithDelay = createPromiseFunctionWithDelay(() => {
          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPES.STORE_MAP_FAMILY_MART_FROZEN,
          );
        });

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              Promise.all([
                multiCheckoutService.saveSessionData({
                  cart_tag_ids: scope.cartTagIds,
                }),
                trackerPromiseWithDelay(),
              ]),
            )
            .then(() => {
              $('#multi_checkout_family_mart_frozen')[0].submit();
            })
            .catch((error) => {
              onLogError({
                error,
                page: PAGE_TYPE.cart,
                debugMessage: 'unable to open e-map of family mart frozen.',
                sourceName:
                  'destinationSectionFamilyMartFrozen#onEMapSubmitClick',
              });
            });
        };
      },
    };
  },
]);
